import React, { useEffect, useRef, useState } from "react";

export function useViewWindowExtender(
  timesheets,
  sortAndFilterOptions,
  setSortAndFilterOptions,
  sectionedTimesheets,
  // setViewWindow,
  sliderId
) {
  const endOfViewWindow = useRef(null);
  let { viewWindow } = sortAndFilterOptions;

  useEffect(() => {
    // Creates an intersection observer at bottom of screen which when triggered,
    //increases the amount of primaries rendered onto the screen.

    if (viewWindow >= timesheets.length) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      // Condition ensures that observer not triggered when searching data
      // or on first load.

      if (
        entries[0].isIntersecting &&
        // !sortAndFilterOptions.searchTerm &&
        sectionedTimesheets.length > 1
      ) {
        setSortAndFilterOptions((prevOptions) => {
          return { ...prevOptions, viewWindow: prevOptions.viewWindow + 1 };
        });
      }
    });

    if (endOfViewWindow.current) {
      observer.observe(endOfViewWindow.current);
    }

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, [
    sortAndFilterOptions.searchTerm,
    sectionedTimesheets,
    timesheets.length,
    sliderId,
  ]);

  return [endOfViewWindow];
}
